__turbopack_context__.v({
  "component": "style-module-scss-module__jyhNEW__component",
  "first-page-grid": "style-module-scss-module__jyhNEW__first-page-grid",
  "pagination": "style-module-scss-module__jyhNEW__pagination",
  "posts-grid": "style-module-scss-module__jyhNEW__posts-grid",
});
